<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!transaction">
      <span class="loader"></span>
    </span>
    <div v-if="transaction" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        value="transaction"
      >
        <tab-pane title="transaction" id="1" :active="true">
          <span slot="title">
            <i class="ni ni-cloud-upload-96"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <transaction-view-global
            :transaction="transaction"
            @onContractUpdated="get"
          />
        </tab-pane>
        <tab-pane
          title="logs"
          id="999"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
        >
          <span slot="title">
            <i class="fa fa-file"></i>
            {{ $t("COMMON.LOGS") }}
          </span>
          <transaction-view-logs :transaction="transaction" />
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { Tabs, TabPane } from "@/components";
import TransactionViewLogs from "../partials/TransactionViewLogs.vue";
import TransactionViewGlobal from "../partials/TransactionViewGlobal.vue";
export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    TransactionViewLogs,
    TransactionViewGlobal,
  },

  mixins: [],

  props: {
    transactionId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      transaction: null,
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch(
          "elixiopayTransactions/get",
          this.transactionId
        );
        this.transaction =
          this.$store.getters["elixiopayTransactions/elixiopayTransaction"];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
  },
};
</script>
